module.exports = __webpack_public_path__ + "images/buroscanbrit6dd60bae24e4f9ff307eae4b024c4422.png";